module.exports = __webpack_public_path__ + "static/media/twitter_icon.4cd91bd7.webp";